import { useContext } from "react";
import usePatientsDetails from "./hooks/usePatientsDetails";
import PageLayout from "../../PageLayout";
import { EButton, ECheckBox, EEmpty, ELabelView, EModal, EPageTitle, ETable, ETextArea, ETextInput } from "../../libs/ui";
import { Avatar, Badge, Grid, Popover, Table } from "@mantine/core";
import moment from "moment";
import { BsArrowLeft, BsCheck2, BsHospital, BsPen, BsPlus } from "react-icons/bs";
import EPhoneInput from "../../libs/ui/src/NumberInput/EPhoneInput";
import { FiAlertCircle, FiCheckCircle } from "react-icons/fi";
import { AppContext } from "../../AppContext";
import EDateInput from "../../libs/ui/src/DateInput/EDateInput";
import EHeader from "../../libs/ui/src/Header/EHeader";
import { EBadge } from "../../libs/ui/src/EBadge/EBadge";
import { DateInput } from "@mantine/dates";
import { AiOutlineEdit } from "react-icons/ai";
import useAdminPatients from "../Admin/Patient/hooks/useAdminPatients";
import { BiMobile } from "react-icons/bi";
import CardOptions from "../../libs/ui/src/Cards/CardOptions";
import { MdUpdate } from "react-icons/md";
import UpdateStatusModal from "./components/UpdateStatusModal";

export default function PatientsDetails() {

  const { role } = useContext(AppContext);

  const {
    isBtnLoading,
    isChecked,
    setIsChecked,
    isOpenVisitModal,
    setIsOpenVisitModal,
    patientDetails,
    visitList,
    patient_id,
    error,
    navigate,
    handleChangeInfo,
    editProfile,
    uniqueNessCheck,
    checkUniqueNumber,
    setUniqueNessCheck,
    updatePatientProfile,
    setIsOpenInfoModal,
    isOpenInfoModal,
    setUpdateInclusionStatus,
    updateInclusionStatus,
    consentFormUrl,
    inclusionStatus,
    handleUpdateInclusionStatus,
    selectedVisit,
    setSelectedVisit,
    updateVisitDate,
    getPatientDetails,
    defaultSelectedVisit,
    isOpenUpdateStatusModal,
    setIsOpenUpdateStatusModal
  } = usePatientsDetails();

  const {
    payloadForAddFollowUpRequest,
    selectedPatient,
    isFollowUpModalOpen,
    setIsFollowUpModalOpen,
    handleAddFollowUpRequest,
    handleUpdatePayload,
  } = useAdminPatients();

  return (
    <PageLayout
      header={
        <EPageTitle
          title="Patient visit Details"
          description="List of all visits done by the patient"
          end={
            <>

              <EButton
                className="btn-blue"
                size="md"
                onClick={() => {
                  navigate("/index");
                }}
              >
                <BsArrowLeft className="" /> Back
              </EButton>
            </>
          }
        />
      }
    >
      <Grid style={{ overflowWrap: "break-word" }}>


        {/* Details section */}

        <Grid.Col span={4}>
          <div className="border rounded-md h-full p-4 pt-1 m-1 bg-slate-50 overflow-hidden">
            <div className="flex justify-between items-center flex-wrap">
              <div className="text-2xl font-semibold text text-slate-600">
                Details
              </div>
              <div className="flex gap-2 flex-wrap">
                {role?.includes("Center") ? <EButton
                  variant={"secondary"}
                  size="md"
                  onClick={() => {
                    setIsOpenUpdateStatusModal(true);
                  }}
                >
                  <MdUpdate /> Update Current Status
                </EButton> : <></>}
                {role?.includes("Center") ? <EButton
                  variant={"secondary"}
                  size="md"
                  onClick={() => {
                    navigate("/index/patient/edit-patient?patient_id=" + patient_id);
                  }}
                >
                  <BsPen className="" /> View / Edit
                </EButton> : <></>}
              </div>
            </div>

            <div className="flex gap-2 mt-4 items-center justify-between flex-wrap">
              <div className="flex gap-2 items-center w-full">
                <Avatar radius={"md"} />
                <div className="w-full">
                  <div className="flex justify-between w-full">
                    <div className="font-bold">
                      {patientDetails?.first_name + " " + patientDetails?.last_name}
                    </div>
                    <div className='cursor-pointer'
                      onClick={() => {
                        setUpdateInclusionStatus(inclusionStatus);
                        setIsOpenInfoModal(true)
                      }}
                    >
                      <Badge

                        size='lg'
                        color={inclusionStatus === "included"
                          ? "green"
                          : inclusionStatus === "excluded"
                            ? "yellow"
                            : "gray"
                        }
                      //    onClick={() => handleUpdateInclusionStatus()}
                      >
                        {inclusionStatus === "included" ? "Included" : inclusionStatus === "excluded" ? "Excluded" : "Pending"}

                      </Badge>
                    </div>
                  </div>
                  <div className="font-medium text-slate-600">
                    {patientDetails?.email}
                  </div>
                </div>
              </div>

            </div>
            <Grid>
              <Grid.Col span={6} className="mt-4">
                <ELabelView
                  label="Mobile no."
                  value={String(patientDetails?.primary_contact_no ?? "-")}
                />
              </Grid.Col>

              <Grid.Col span={6} className="mt-4">
                <ELabelView
                  label="Alternate Mobile no."
                  value={String(patientDetails?.alternate_contact_no ?? "-")}
                />
              </Grid.Col>
              <Grid.Col span={6}>
                <ELabelView
                  label="Hospital Number"
                  value={String(
                    patientDetails?.hospital_no ?? "-"
                  )}
                />
              </Grid.Col>
              <Grid.Col span={6}>
                <ELabelView
                  label="Recruitment Date"
                  value={patientDetails?.recruitment_date ? moment(patientDetails?.recruitment_date).format("DD MMM YYYY") : "-"}
                />
              </Grid.Col>
              {patientDetails?.father_name ? <Grid.Col span={6}>
                <ELabelView
                  label="Father Name"
                  value={String(patientDetails?.father_name || "-")}
                />
              </Grid.Col> : <></>}
              {patientDetails?.mother_name ? <Grid.Col span={6}>
                <ELabelView
                  label="Mother Name"
                  value={String(patientDetails?.mother_name || "-")}
                />
              </Grid.Col> : <></>}
              <Grid.Col span={6}>
                <ELabelView
                  label="Age"
                  value={String(patientDetails?.age || "-")}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <ELabelView
                  label="Address"
                  value={String(patientDetails?.address ?? "-")}
                />
              </Grid.Col>
            </Grid>
          </div>
        </Grid.Col>

        {/* Visit Section */}


        {role?.includes("Center") || 1 ?
          <Grid.Col span={8}>
            <div className="border rounded-md pt-1 h-full flex flex-col m-1">
              <EPageTitle
                title="Visit List"
                className="px-2"
                end={
                  role?.includes("Center") ?
                    <div className="flex gap-2">
                      <EButton
                        size="md"
                        onClick={() => {
                          setIsOpenVisitModal(true);
                        }}
                      >
                        <BsPlus size={20} /> Create New Visit
                      </EButton>
                    </div>
                    : <></>
                }
              />
              <div className="mt-4 flex flex-1">
                {visitList?.length ? (
                  <ETable>
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th className="whitespace-nowrap">Visit No.</Table.Th>
                        <Table.Th className="whitespace-nowrap">Visit Date</Table.Th>
                        {/* <Table.Th>center State</Table.Th>
                      <Table.Th>center Address</Table.Th> */}
                        {/* <Table.Th>Personal History</Table.Th> */}
                        <Table.Th className="whitespace-nowrap">Clinical History</Table.Th>
                        <Table.Th className="whitespace-nowrap">Gall Stone</Table.Th>
                        <Table.Th className="whitespace-nowrap">Anthropometric Measurement</Table.Th>
                        {/* <Table.Th>Dietary Determinants</Table.Th> */}
                        <Table.Th className="whitespace-nowrap">Investigations</Table.Th>
                        <Table.Th className="whitespace-nowrap">Radiology</Table.Th>
                        {/* <Table.Th>Surgery</Table.Th> */}
                        {/* <Table.Th>Histology</Table.Th> */}
                        {/* <Table.Th>Stone Analysis</Table.Th> */}
                        <Table.Th className="whitespace-nowrap">Cost Effective Analysis</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody className="text-center">
                      {visitList?.map((visit, index) => {
                        return (
                          <Table.Tr key={visit?.id}>
                            <Table.Td width={40}>
                              <p
                                className="text-blue-600 whitespace-nowrap cursor-pointer"
                                onClick={() => {
                                  if (index == 0) {
                                    navigate(
                                      `/index/patient/visit?patient_id=${patient_id}&visit_id=${visit?.id}`, { state: { gender: patientDetails?.gender } }
                                    );
                                    // window.location.reload();
                                  } else {
                                    navigate(
                                      `/index/patient/new-visit?patient_id=${patient_id}&visit_id=${visit?.id}`, { state: { gender: patientDetails?.gender } }
                                    );
                                    // window.location.reload();
                                  }
                                }}
                              >
                                {index == 0 ? "Base Line" : visit?.tele_followup ? (index) + ". Tele Follow Up" : (index) + ". Follow Up"}
                              </p>
                            </Table.Td>
                            <Table.Td className="whitespace-nowrap" >
                              <Popover
                                closeOnClickOutside={false}
                                withinPortal={true}
                                opened={selectedVisit?.id === visit.id}
                                onClose={() => setSelectedVisit(defaultSelectedVisit)}
                                onOpen={() => setSelectedVisit({
                                  id: visit?.id,
                                  visit_Date: visit?.visit_date ? new Date(visit?.visit_date) : null,
                                  tele_followup: visit?.tele_followup || false,
                                })}
                              >
                                <Popover.Target>
                                  <div className="cursor-pointer"
                                    onClick={() => {
                                      setSelectedVisit({
                                        id: visit?.id,
                                        visit_Date: visit?.visit_date ? new Date(visit?.visit_date) : null,
                                        tele_followup: visit?.tele_followup || false,
                                      })
                                    }}
                                  >
                                    <div className="flex items-center gap-1">
                                      <EBadge
                                        label={visit?.visit_date ? moment(visit?.visit_date).format("DD-MM-YYYY") : "--/--/----"} variant={"blue"}
                                      />
                                      <AiOutlineEdit />
                                    </div>
                                  </div>
                                </Popover.Target>
                                <Popover.Dropdown className="">
                                  <EHeader
                                    title="Visit Date"
                                    subTitle="Manage Visit Date"
                                    size="xs"
                                  />
                                  <DateInput
                                    size="xs"
                                    popoverProps={{
                                      withinPortal: true,
                                      closeOnClickOutside: false
                                    }}
                                    className="mt-4"
                                    placeholder="Select Date"
                                    value={selectedVisit?.visit_Date ? selectedVisit?.visit_Date : undefined}
                                    onChange={(e) => setSelectedVisit({ ...selectedVisit, visit_Date: e || null })}
                                  />
                                  <div className="flex justify-end gap-2 p-1 mt-3">
                                    <EButton
                                      variant="outline"
                                      size="sm"
                                      onClick={() => {
                                        setSelectedVisit(defaultSelectedVisit)
                                      }}
                                    >
                                      Cancel
                                    </EButton>

                                    <EButton
                                      size="sm"
                                      disabled={!selectedVisit?.visit_Date}
                                      onClick={() => {
                                        selectedVisit?.visit_Date && updateVisitDate(selectedVisit?.id, selectedVisit?.visit_Date);
                                      }}
                                    >Save</EButton>
                                  </div>
                                </Popover.Dropdown>
                              </Popover>
                            </Table.Td>
                            {/* <Table.Td>
              {visit?.demographic_information ? (
                <div className="flex justify-center">
                <BsCheck2 size={28} fontWeight={900} color="green"/>
                </div>
              ) : (
                <p className="font-bold text-2xl">__</p>
              )}
            </Table.Td> */}
                            <Table.Td>
                              {visit?.clinical_history ? (
                                <div className="flex justify-center">
                                  <BsCheck2
                                    size={28}
                                    fontWeight={900}
                                    color="green" />
                                </div>
                              ) : (
                                <p className="text-2xl">__</p>
                              )}
                            </Table.Td>
                            <Table.Td>
                              {visit?.gallstones_history ? (
                                <div className="flex justify-center">
                                  <BsCheck2
                                    size={28}
                                    fontWeight={900}
                                    color="green" />
                                </div>
                              ) : (
                                <p className="text-2xl">__</p>
                              )}
                            </Table.Td>
                            <Table.Td>
                              {visit?.anthropometric_measurements ? (
                                <div className="flex justify-center">
                                  <BsCheck2
                                    size={28}
                                    fontWeight={900}
                                    color="green" />
                                </div>
                              ) : (
                                <p className="text-2xl">__</p>
                              )}
                            </Table.Td>
                            {/* <Table.Td>
              {visit?.dietary_determinants ? (
                <div className="flex justify-center">
                <BsCheck2 size={28} fontWeight={900} color="green"/>
                </div>
              ) : (
                <p className="text-2xl">__</p>
              )}
            </Table.Td> */}
                            <Table.Td>
                              {visit?.investigations ? (
                                <div className="flex justify-center">
                                  <BsCheck2
                                    size={28}
                                    fontWeight={900}
                                    color="green" />
                                </div>
                              ) : (
                                <p className="text-2xl">__</p>
                              )}
                            </Table.Td>
                            <Table.Td>
                              {visit?.radiology ? (
                                <div className="flex justify-center">
                                  <BsCheck2
                                    size={28}
                                    fontWeight={900}
                                    color="green" />
                                </div>
                              ) : (
                                <p className="text-2xl">__</p>
                              )}
                            </Table.Td>
                            {/* <Table.Td>
              {visit?.surgery_gs_patients ? (
                <div className="flex justify-center">
                <BsCheck2 size={28} fontWeight={900} color="green"/>
                </div>
              ) : (
                <p className="text-2xl">__</p>
              )}
            </Table.Td> */}
                            {/* <Table.Td>
              {visit?.histology_gb_tissue ? (
                <div className="flex justify-center">
                <BsCheck2 size={28} fontWeight={900} color="green"/>
                </div>
              ) : (
                <p className="text-2xl">__</p>
              )}
            </Table.Td> */}
                            {/* <Table.Td>
              {visit?.stone_analysis ? (
                <div className="flex justify-center">
                <BsCheck2 size={28} fontWeight={900} color="green"/>
                </div>
              ) : (
                <p className="text-2xl">__</p>
              )}
            </Table.Td> */}

                            <Table.Td>
                              {visit?.cost_effective_analysis ? (
                                <div className="flex justify-center">
                                  <BsCheck2
                                    size={28}
                                    fontWeight={900}
                                    color="green" />
                                </div>
                              ) : (
                                <p className="text-2xl">__</p>
                              )}
                            </Table.Td>
                          </Table.Tr>
                        );
                      })}
                    </Table.Tbody>
                  </ETable>
                ) : (
                  <EEmpty title="Patient visit list is empty - no data available" />
                )}
              </div>
            </div>
          </Grid.Col> : <></>}
      </Grid>

      {/* Visit start confirmation Modal */}
      <EModal
        title={
          <EHeader
            title="Patient Visit"
            subTitle="Manage patient visit"
          />
        }
        isOpen={isOpenVisitModal}
        setIsOpen={() => {
          setIsOpenVisitModal(false)
          setSelectedVisit(defaultSelectedVisit)
        }}
        size={"xl"}
      >
        <div className="grid grid-cols-2 gap-2 gap-x-6 pt-3">
          <CardOptions
            active={!selectedVisit?.tele_followup}
            title="Physical followup"
            description="Patient will visit the center for a physical checkup and consultation."
            icon={<BsHospital size={28} />}
            onClick={() => setSelectedVisit({ ...selectedVisit, tele_followup: false })}
          />

          <CardOptions
            active={selectedVisit?.tele_followup}
            title="Tele followup"
            description="Patient will have a telephonic consultation with the doctor."
            icon={<BiMobile size={28} />}
            onClick={() => setSelectedVisit({ ...selectedVisit, tele_followup: true })}
          />

          <ETextInput
            required
            size="md"
            label="First Name"
            error={error?.name}
            value={editProfile?.first_name}
            onChange={(e) => {
              handleChangeInfo("first_name", e?.target?.value);
            }}
          />

          <ETextInput
            required
            size="md"
            label="Last Name"
            value={editProfile?.last_name}
            onChange={(e) => handleChangeInfo("last_name", e?.target?.value)}
          />

          <EPhoneInput
            required
            size="md"
            label="Mobile no."
            error={error?.mobileNo}
            value={editProfile?.primary_contact_no}
            rightSection={
              uniqueNessCheck?.mobileNo == "notUnique" ? (
                <FiAlertCircle size={22} color="red" />
              ) : uniqueNessCheck?.mobileNo?.toLowerCase() == "unique" ? (
                <FiCheckCircle size={22} color="green" />
              ) : (
                <></>
              )
            }
            // icon={"+91"}
            maxLength={10}
            onChange={(e) => {
              handleChangeInfo("primary_contact_no", e);
              if (String(e).length == 10) {
                checkUniqueNumber(e, "mobileNo");
              } else {
                setUniqueNessCheck({
                  ...uniqueNessCheck,
                  mobileNo: "not_checked",
                });
              }
            }}
          />
          <EPhoneInput
            hideControls
            size="md"
            label="Alternate Mobile No."
            required
            error={error?.alternateNo}
            placeholder="Alternate Mobile No."
            value={editProfile?.alternate_contact_no}
            rightSection={
              uniqueNessCheck?.alternateNo == "notUnique" ? (
                <FiAlertCircle size={22} color="red" />
              ) : uniqueNessCheck?.alternateNo?.toLowerCase() ==
                "unique" ? (
                <FiCheckCircle size={22} color="green" />
              ) : (
                <></>
              )
            }
            // icon={"+91"}
            maxLength={10}
            onChange={(e) => {
              // handleError("alternateNo", "");
              handleChangeInfo("alternate_contact_no", e);
              if (String(e).length == 10) {
                checkUniqueNumber(e, "alternateNo");
              } else {
                setUniqueNessCheck({
                  ...uniqueNessCheck,
                  alternateNo: "not_checked",
                });
              }
            }}
          />
          <EPhoneInput
            hideControls
            size="md"
            label="Secondary Alternate Mobile No."
            error={error?.secondaryNo}
            placeholder=" Mobile No."
            value={editProfile?.secondary_alternate_contact_no}
            rightSection={
              uniqueNessCheck?.secondaryNo == "notUnique" ? (
                <FiAlertCircle size={22} />
              ) : uniqueNessCheck?.secondaryNo?.toLowerCase() ==
                "unique" ? (
                <FiCheckCircle size={22} color="green" />
              ) : (
                <></>
              )
            }
            // icon={"+91"}
            maxLength={10}
            onChange={(e) => {
              // handleError("secondaryNo", "");
              handleChangeInfo("secondary_alternate_contact_no", e);
              if (String(e).length == 10) {
                checkUniqueNumber(e, "secondaryNo");
              } else {
                setUniqueNessCheck({
                  ...uniqueNessCheck,
                  secondaryNo: "not_checked",
                });
              }
            }}
          />

          <EDateInput
            label="Visit Date"
            size="md"
            required
            placeholder="Select Date"
            value={selectedVisit?.visit_Date ? selectedVisit?.visit_Date : undefined}
            onChange={(e) => setSelectedVisit({ ...selectedVisit, visit_Date: e || null })}
          />

        </div>

        <div className="flex justify-between items-center border-t pt-3 mt-8">
          <ECheckBox
            checked={isChecked}
            onChange={(e) => setIsChecked(e?.target.checked)}
            label="Are you ready, to start a new visit with these details ?"
          />
          <EButton
            disabled={!isChecked || !selectedVisit?.visit_Date}
            loading={isBtnLoading}
            onClick={() => updatePatientProfile()}
          >
            Start Visit
          </EButton>
        </div>
      </EModal>

      <EModal
        title="Eligibility Status"
        isOpen={isOpenInfoModal}
        setIsOpen={() => {
          setIsOpenInfoModal(false);
        }}
        closeOnClickOutside={false}
      >
        <div className="bg-slate-100 p-3 rounded-md">
          <div className="border-b border-slate-300 mb-4 pb-4">
            <div className="flex flex-row items-center justify-between mb-4">
              <div className="text-green-700 font-semibold text-2xl">
                Screening for Eligibility for GS
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <ECheckBox label="Informed consent" checked={consentFormUrl ? true : false} disabled />
              <ECheckBox
                label="Ultrasound evidence of GS"
                checked={patientDetails?.ultrasound_evidence_of_gs === "yes"}
                disabled
              />
              <ECheckBox
                label="Age (18 - 80) years"
                checked={patientDetails?.age ? patientDetails?.age >= 18 && patientDetails?.age <= 80 : false}
                disabled
              />
            </div>
          </div>
          <div>
            <div className="flex flex-row items-center justify-between mb-4">
              <div className="text-green-700 font-semibold text-2xl">
                Screening for Eligibility for GBC
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <ECheckBox label="Informed consent" checked={consentFormUrl ? true : false} disabled />
              <ECheckBox
                label="Ultrasound evidence of GS"
                checked={patientDetails?.ultrasound_evidence_of_gs === "yes"}
                disabled
              />
              <ECheckBox
                label="Age (18 - 80) years"
                checked={patientDetails?.age ? patientDetails?.age >= 18 && patientDetails?.age <= 80 : false}
                disabled
              />
              <ECheckBox
                label="Definitive Diagnosis"
                checked={patientDetails?.definitive_diagnosis?.includes("yes")}
                disabled
              />
              <ECheckBox
                label="Severe co-morbidities"
                checked={patientDetails?.severe_comorbidities === "yes"}
                disabled
              />
              <ECheckBox
                label="Unwilling for FU"
                checked={patientDetails?.unwilling_for_fu === "yes"}
                disabled
              />
            </div>
          </div>
        </div>

        <div className='flex justify-end gap-3 mt-3'>
          <ECheckBox
            label="Include this patient in the study"
            checked={updateInclusionStatus === "included"}
            onChange={(e) => {
              setUpdateInclusionStatus(updateInclusionStatus === "included" ? "" : "included");
            }}
          />


          <ECheckBox
            label="Exclude this patient from the study"
            checked={updateInclusionStatus === "excluded"}
            onChange={(e) => {
              setUpdateInclusionStatus(updateInclusionStatus === "excluded" ? "" : "excluded");
            }}
          />
        </div>

        <div className="flex justify-end mt-5 border-t pt-3">
          <EButton
            className="btn-blue"
            onClick={() => {
              handleUpdateInclusionStatus();
            }}
            loading={isBtnLoading}
          >
            Continue
          </EButton>
        </div>
      </EModal>

      {/* Tele Follow Up Modal */}
      <EModal
        isOpen={isFollowUpModalOpen}
        title={
          editProfile?.first_name +
          " " +
          editProfile?.last_name +
          (editProfile?.primary_contact_no
            ? " (" + editProfile?.primary_contact_no + ")"
            : "")
        }
        size="sm"
        setIsOpen={() => {
          setIsFollowUpModalOpen(false);
        }}
      >
        <div>
          <DateInput
            label="Date"
            value={payloadForAddFollowUpRequest?.followup_date}
            onChange={(e) => {
              handleUpdatePayload("followup_date", e);
            }}
          />
          <ETextArea
            value={payloadForAddFollowUpRequest?.remarks}
            onChange={(e) => {
              handleUpdatePayload("remarks", e?.target?.value);
            }}
            className="mt-5"
            label="Remarks"
          />
        </div>
        <EButton
          disabled={
            !payloadForAddFollowUpRequest?.remarks
          }
          onClick={async () => {
            await editProfile?.id && handleAddFollowUpRequest(editProfile?.id + "")
            getPatientDetails()
          }}
          className="mt-5 w-full flex items-center justify-center"
        >
          Submit
        </EButton>
      </EModal>

      {/* Update Status Modal */}
      {
        isOpenUpdateStatusModal && patientDetails &&
        <UpdateStatusModal
          patientDetails={patientDetails}
          onClose={(SuccessTrue) => {
            if (SuccessTrue) {
              getPatientDetails()
              setIsOpenUpdateStatusModal(false)
            }
            setIsOpenUpdateStatusModal(false)
          }}
        />
      }

    </PageLayout >
  );
}
